import request from '@/utils/request.js'
import main from '@/main'

const basePath = '/Function/Bus/';

const state = {};

const mutations = {};

const actions = {

  CheckTeamOrderInClient({commit}, view) {
    return request.PromiseCall(basePath, 'CheckTeamOrderInClient', view);
  }


};

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/Function/Bus/index.js